import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { TRANSLATIONS_EN } from "./en/translations";
import { TRANSLATIONS_SV } from "./sv/translations";
import { TRANSLATIONS_FA } from "./fa/translations";
import { TRANSLATIONS_NO } from "./no/translations";
import { TRANSLATIONS_FI } from "./fi/translations";
import { TRANSLATIONS_DE } from "./de/translations";
import { TRANSLATIONS_FR } from "./fr/translations";
import { TRANSLATIONS_AR } from "./ar/translations";
import { TRANSLATIONS_ES } from "./es/translations";
import { TRANSLATIONS_TR } from "./tr/translations";
import { TRANSLATIONS_PL } from "./pl/translations";
import { TRANSLATIONS_AM } from "./am/translations";
import { TRANSLATIONS_DA } from "./da/translations";

import { RULES_EN } from "./en/rules";
import { RULES_SV } from "./sv/rules";
import { RULES_FA } from "./fa/rules";
import { RULES_NO } from "./no/rules";
import { RULES_FI } from "./fi/rules";
import { RULES_DE } from "./de/rules";
import { RULES_FR } from "./fr/rules";
import { RULES_AR } from "./ar/rules";
import { RULES_ES } from "./es/rules";
import { RULES_TR } from "./tr/rules";
import { RULES_PL } from "./pl/rules";
import { RULES_AM } from "./am/rules";
import { RULES_DA } from "./da/rules";

import { API_EN } from "./en/api_betting";
import { API_SV } from "./sv/api_betting";
import { API_FA } from "./fa/api_betting";
import { API_NO } from "./no/api_betting";
import { API_FI } from "./fi/api_betting";
import { API_DE } from "./de/api_betting";
import { API_FR } from "./fr/api_betting";
import { API_AR } from "./ar/api_betting";
import { API_ES } from "./es/api_betting";
import { API_TR } from "./tr/api_betting";
import { API_PL } from "./pl/api_betting";
import { API_AM } from "./am/api_betting";
import { API_DA } from "./da/api_betting";

import { TEAMS_EN } from "./en/teams";
import { TEAMS_SV } from "./sv/teams";
import { TEAMS_FA } from "./fa/teams";
import { TEAMS_NO } from "./no/teams";
import { TEAMS_FI } from "./fi/teams";
import { TEAMS_DE } from "./de/teams";
import { TEAMS_FR } from "./fr/teams";
import { TEAMS_AR } from "./ar/teams";
import { TEAMS_ES } from "./es/teams";
import { TEAMS_TR } from "./tr/teams";
import { TEAMS_PL } from "./pl/teams";
import { TEAMS_AM } from "./am/teams";
import { TEAMS_DA } from "./da/teams";

import { MARKETS_EN } from "./en/markets";
import { MARKETS_SV } from "./sv/markets";
import { MARKETS_FA } from "./fa/markets";
import { MARKETS_NO } from "./no/markets";
import { MARKETS_FI } from "./fi/markets";
import { MARKETS_DE } from "./de/markets";
import { MARKETS_FR } from "./fr/markets";
import { MARKETS_AR } from "./ar/markets";
import { MARKETS_ES } from "./es/markets";
import { MARKETS_TR } from "./tr/markets";
import { MARKETS_PL } from "./pl/markets";
import { MARKETS_AM } from "./am/markets";
import { MARKETS_DA } from "./da/markets";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: TRANSLATIONS_EN,      
                rules: RULES_EN,
                api: API_EN,
                teams: TEAMS_EN,
                markets: MARKETS_EN                    
            },
            sv: {
                translation: TRANSLATIONS_SV,
                rules: RULES_SV,
                api: API_SV,
                teams: TEAMS_SV,
                markets: MARKETS_SV
            },
            fa: {
                translation: TRANSLATIONS_FA,
                rules: RULES_FA,
                api: API_FA,
                teams: TEAMS_FA,
                markets: MARKETS_FA
            },
            no: {
                translation: TRANSLATIONS_NO,
                rules: RULES_NO,
                api: API_NO,
                teams: TEAMS_NO,
                markets: MARKETS_NO
            },
            fi: {
                translation: TRANSLATIONS_FI,
                rules: RULES_FI,
                api: API_FI,
                teams: TEAMS_FI,
                markets: MARKETS_FI
            },
            de: {
                translation: TRANSLATIONS_DE,
                rules: RULES_DE,
                api: API_DE,
                teams: TEAMS_DE,
                markets: MARKETS_DE
            },
            fr: {
                translation: TRANSLATIONS_FR,
                rules: RULES_FR,
                api: API_FR,
                teams: TEAMS_FR,
                markets: MARKETS_FR
            },
            ar: {
                translation: TRANSLATIONS_AR,
                rules: RULES_AR,
                api: API_AR,
                teams: TEAMS_AR,
                markets: MARKETS_AR
            },
            es: {
                translation: TRANSLATIONS_ES,
                rules: RULES_ES,
                api: API_ES,
                teams: TEAMS_ES,
                markets: MARKETS_ES
            },
            tr: {
                translation: TRANSLATIONS_TR,
                rules: RULES_TR,
                api: API_TR,
                teams: TEAMS_TR,
                markets: MARKETS_TR
            },
            pl: {
                translation: TRANSLATIONS_PL,
                rules: RULES_PL,
                api: API_PL,
                teams: TEAMS_PL,
                markets: MARKETS_PL
            },
            am: {
                translation: TRANSLATIONS_AM,
                rules: RULES_AM,
                api: API_AM,
                teams: TEAMS_AM,
                markets: MARKETS_AM
            },
            da: {
                translation: TRANSLATIONS_DA,
                rules: RULES_DA,
                api: API_DA,
                teams: TEAMS_DA,
                markets: MARKETS_DA
            },
        },
    });

i18n.changeLanguage("en")
    .then((r) => {console.log("lang set to", r)});